import '@fontsource/nunito-sans/400.css';
import '@fontsource/nunito-sans/600.css';
import '@fontsource/nunito-sans/700.css';
import '@fontsource/nunito-sans/800.css';
import '@fontsource/nunito-sans/400-italic.css';
import '@fontsource/noto-sans-devanagari/600.css';
import './styles.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes, useParams } from 'react-router';
import { PrefsProvider } from './components/Prefs';
import { AdminPage } from './pages/Admin';
import { Home } from './pages/Home';
import { HowToPlay, NotFound, SuggestPage } from './pages/Info';
import { PackEditorPage, PackViewPage, PacksPage } from './pages/Packs';
import { RoomPage } from './pages/room/RoomPage';
import { Tv } from './pages/Tv';
import { routes as accountRoutes } from './pages/account/routes';
import { routes as gameRoutes } from './pages/games/routes';
import { routes as marketingRoutes } from './pages/marketing/routes';
import { routes as shopRoutes } from './pages/shop/routes';

const extraRoutes = [...marketingRoutes, ...gameRoutes, ...shopRoutes, ...accountRoutes];

/** Old /mega and /meta links from the first version open TV mode. */
function LegacyTv() {
  return <Navigate to={`/tv/${useParams().code ?? ''}`} replace />;
}

// Older versions installed a service worker with an offline copy of the cards. Remove it.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((all) => all.forEach((r) => r.unregister()))
    .catch(() => {});
}
if ('caches' in window) {
  caches
    .keys()
    .then((keys) => keys.filter((k) => k.startsWith('cm-')).forEach((k) => caches.delete(k)))
    .catch(() => {});
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PrefsProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/game/:code" element={<RoomPage />} />
          <Route path="/game/:code/settings" element={<RoomPage />} />
          <Route path="/tv/:code" element={<Tv />} />
          <Route path="/mega/:code" element={<LegacyTv />} />
          <Route path="/meta/:code" element={<LegacyTv />} />
          <Route path="/packs" element={<PacksPage />} />
          <Route path="/packs/new" element={<PackEditorPage />} />
          <Route path="/packs/:code" element={<PackViewPage />} />
          <Route path="/packs/:code/edit" element={<PackEditorPage />} />
          <Route path="/suggest" element={<SuggestPage />} />
          <Route path="/how-to-play" element={<HowToPlay />} />
          <Route path="/admin" element={<AdminPage />} />
          {extraRoutes.map((r) => (
            <Route key={r.path} path={r.path} element={r.element} />
          ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </PrefsProvider>
  </StrictMode>,
);
